import { Button as MuiButton, makeStyles } from "@material-ui/core";
import React from "react";
import { useRefDialog } from "../hooks/useRefDialog";
const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: 23,
        [theme.breakpoints.down("sm")]: {
            marginTop: 20
        }
    }
}));
export const Button = ({ name, color = "primary", variant = "contained", value, children }) => {
    const classes = useStyles();
    const { open } = useRefDialog(name);
    return (React.createElement(MuiButton, { variant: variant, color: color, className: classes.root, onClick: () => open(children) }, value));
};
//# sourceMappingURL=Button.js.map